import React, {Component} from 'react';
import {saveAs} from 'file-saver';
import {connect} from 'react-redux';
import * as firebase from 'firebase';

import ModulesUtils from '../../infra/ModulesUtils';
import Config from '../payroll/PayrollConfig';

const json2csv = require('json2csv');

class PayrollReportExporter extends Component {
  constructor(props){
    super(props)

    this.state = {
      processing: false,
    }
    this.listener = this.onUpdate
  }

  componentDidMount(){
    if (this.props.startProcess && !this.state.processing){
      this.setState({processing : true})
      console.log('Starting Payroll Exporter...');
      this.start();
    }
  }

  componentWillReceiveProps(props){
    if (props.startProcess && !this.state.processing){
      this.setState({processing : true})
      console.log('Starting Payroll Exporter...');
      this.start();
    }
  }

  start(){
    const allKeys = this.props.reportHeader.slice();
    let result = [];
    Object
    .keys(this.props.reportData)
    .forEach(key => {
      const workerData = [];
      Object
      .keys(this.props.reportData[key])
      .forEach((date) => {
        const row = this.toCSVFormat(allKeys, key, this.props.reportData[key][date].data)
        row['date'] = date;
        row['workerId'] = key;
        workerData.push(row)
      })
      //sort data
      workerData.sort((dateA, dateB) => new Date(dateA.date) - new Date(dateB.date));
      //concat to result
      result = result.concat(workerData);
    })
    this.exportCSV(allKeys, result);
  }

  toCSVFormat(allKeys, id, data){
    const rowData = {}
    allKeys.forEach(key => {
      if (data[key]){
        rowData[key] = Config[key].toCSVFormat(data[key]);
      }
    })
    return rowData;
  }

  exportCSV(allKeys, data){
    allKeys.unshift('date');
    allKeys.unshift('workerId');
    const result = json2csv({ data: data, fields: allKeys });
    const blob = new Blob([result], {type: "text/csv;charset=utf-8"});
    saveAs(blob, "payrollReport.csv");
    this.props.onExportComplete(); //turn export flag off.
    this.setState({processing : false, data: {}}) //reset data and processing flag.
  }

  render(){
    return null;
  }
}

function mapStateToProps(state, ownProps) {

  const argsHeader = state.reports.headers['PAYROLL_HEADERS'];
  const argsData = state.reports.payroll;
  let reportHeader = [];
  let reportData = {};
  if (argsHeader && argsHeader.columnHeaders){
    reportHeader = argsHeader.columnHeaders
  }
  if (argsData){
    reportData = argsData
  }
  return {
    reportHeader : reportHeader,
    reportData : reportData
  };
};

export default connect(mapStateToProps)(PayrollReportExporter);



// WEBPACK FOOTER //
// ./src/reports/common/PayrollReportExporter.js